import { useState, useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import TextInput from '../../../components/Inputs/TextInput';
import PhoneInput from '../../../components/Inputs/PhoneInput';

import styles from '../styles.module.scss';

import { useSelector } from 'react-redux';
import { selectIsLoading } from '../../../redux/selectors/miscellaneous';
import { getCountryCode } from '../../../utils/countryCode';
import { phonenumberVerification } from '../../../utils/formValdations';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import Typography from '../../../components/Typography/Typography';
import SButton from '../../../components/SButton/SButton';
import UILink from '../../../components/Buttons/UILink';
import routes from '../../../constants/routes';
import useIsMobile from '../../../hooks/useIsMobile';

const LoginForm = ({ handleLoginAttempt }) => {

  const history = useHistory();
  const isMobile = useIsMobile();

  const [countryCode, setCountryCode] = useState('91');
  const [phoneNumber, setPhoneNumber] = useState({ value: '', error: '' });
  const [password, setPassword] = useState({ value: '', error: '' });

  const isLoading = useSelector(selectIsLoading);

  useEffect(() => {
    try {
      const code = getCountryCode();
      if (code) setCountryCode(code?.countryCode);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e?.currentTarget;

    const errorText = 'Please enter a valid';
    if (name === 'phoneNumber') {
      const error = !phonenumberVerification(`+${countryCode}${value}`)
        ? `${errorText} Phone Number`
        : '';
      setPhoneNumber({ value, error });
    }
    if (name === 'password') {
      const error = value.length <= 4 ? `${errorText} password` : '';
      setPassword({ value, error });
    }
  };

  const handlesubmit = useCallback(
    (e) => {
      handleLoginAttempt({
        phoneNumber: `+${countryCode}${phoneNumber?.value}`,
        password: password.value,
      });
    },
    [handleLoginAttempt, countryCode, phoneNumber?.value, password.value],
  );

  const disabled = useMemo(() => {
    if (
      phoneNumber?.value === '' ||
      phoneNumber?.error !== '' ||
      password?.value === '' ||
      password?.error !== '' ||
      isLoading
    ) {
      return true;
    }
    return false;
  }, [phoneNumber, password, isLoading]);

  return (
    <FlexColumn alignItems='start' className={styles['login-form-container']}>
      <Typography variant={"b1M"}>Login</Typography>
      <PhoneInput
        name="phoneNumber"
        placeholder="Phone number"
        type="number"
        value={phoneNumber?.value}
        onChange={handleChange}
        error={phoneNumber?.error}
        defaultCountryCode={countryCode}
        handleCountryCode={(code) => setCountryCode(code)}
      />

      <TextInput
        name="password"
        placeholder="Password"
        type="password"
        value={password?.value || ""}
        onChange={handleChange}
        error={password.error}
      />
      <SButton style={{ marginTop: '2rem' }} fullWidth variant={"primary"} color={"info"} onClick={handlesubmit} disabled={disabled}>Login</SButton>
      <UILink
        style={{ marginLeft: isMobile ? '1rem' : '0', transition: 'none' }}
        text="Forgot Password"
        disabled={false}
        handleSubmit={() => history.push(routes.public.forgotPassword)}
      />
    </FlexColumn>
  );
};

export default LoginForm;
